module.exports = __webpack_public_path__ + "static/media/insta.e59f1e67.svg";